import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import { withStyles, List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, Typography, Divider, Paper, colors, Button } from '@material-ui/core'
import Dashboard from '@material-ui/icons/Dashboard'
import DevicesOther from '@material-ui/icons/DevicesOther'
import ColorLens from '@material-ui/icons/ColorLens'
import Build from '@material-ui/icons/Build'
import Code from '@material-ui/icons/Code'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import Close from '@material-ui/icons/Close'

import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {PageContainer, SideMenuDrawer, FormElement, SubmitButton, ArrowToolTip, Loader, MenuButton} from '../../components/components'
import {toTitleCase, metaReverseLookup, clearFormFields} from '../../util/misc'
import FormElementType from '../../components/FormElement/FormElementType'
import { validations } from '../../util/validations'
import {metaActions} from '../../core/actions'
import {apiResourcesUrl} from '../../core/request'
import {titlePrefix} from '../../index'

const styles = theme => ({
    container: {
        display: 'flex'
    },

    toolbar: theme.mixins.toolbar,

    drawerTitle: {
        textAlign: 'center',
        fontSize: '1.3em',
        fontWeight: 300,
        paddingTop: '0.5em',
        paddingBottom: '0.5em'
    },

    badge: {
        marginRight: '3em',
        backgroundColor: 'green',
        color: '#fff',
        borderRadius: '0.3em',
        paddingLeft: '1.3em',
        paddingRight: '1.3em'
    },

    formContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '2em'
    },

    formTitle: {
        fontSize: '1.5em',
        fontWeight: 300,
        paddingTop: '0.5em',
        paddingBottom: '0.5em'
    },

    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '1em',
        marginBottom: '1em'
    },

    selectedCategoryItem: {
        backgroundColor: colors.red[500],
        color: '#fff',
        '&:hover': {
            backgroundColor: colors.red[500]
        }
    },

    selectedCategoryItemText: {
        color: '#fff'
    },

    iconItem: {
        height: '100px',
        width: 'auto',
        marginRight: '2em'
    },

    iconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItem: 'center',
        marginTop: '1.5em'
    },

    pageContainer: {
        display: 'flex',
        flexDirection: 'column'
    },

    actionButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },

    stopEditingButton: {
        marginLeft: '1em'
    },

    stopEditingIcon: {
        marginRight: '0.3em'
    }
})

const categoryIcons = {
    categories: Dashboard,
    interfaces: ColorLens,
    platforms: DevicesOther,
    frameworks: Build,
    languages: Code
}

const mapStateToProps = state => ({
    metas: state.meta.metas,
    isFetchingMetas: state.meta.isFetchingMetas,
    isUploadingMeta: state.meta.isUploadingMeta,
    isUpdatingMeta: state.meta.isUpdatingMeta,
    user: state.auth.user,
    error: state.meta.error
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...metaActions}, dispatch)
})

const metaTypes = ['categories', 'interfaces', 'platforms', 'frameworks', 'languages']

class Settings extends Component {
    state = {
        useImgFromUrl: false,
        selectedCategory: 'categories',
        isDisabled: true,
        editingMeta: null
    }

    componentDidMount () {
        document.title = `${titlePrefix}Settings/Icon Manager`
        if (this.props.metas.length < 1) this.props.getMetas()
    }

    onUseImgUrlCheckBoxChanged = useImgFromUrl => this.setState({useImgFromUrl})

    formFieldInputs = {}

    formFields = () => [
        {label: 'Name', name: 'name', minLength: 2, maxLength: 25, type: 'text', required: true},
        {label: 'Upload From Url', name: 'uploadFromUrl', elementType: FormElementType.CheckBox, onChange: this.onUseImgUrlCheckBoxChanged},
        {label: 'Icon URL', name: 'imageUrl', minLength: 1, maxLength: 250, type: 'text', validations: validations.meta.iconUrl, required: true},
        {label: <Fragment>Drag & Drop your <span className="filepond--label-action">Image/Icon </span> or <span className="filepond--label-action"> Browse </span></Fragment>, name: 'image', elementType: FormElementType.ImageDropper, imagePreviewSize: 'icon', required: true, defaultImg: this.state.editingMeta ? `${apiResourcesUrl}/meta/${this.state.editingMeta.iconUrl}` : null}
    ]

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.formFieldInputs).find(key => (!this.formFieldInputs[key].state.isValid)) !== undefined
        this.setState({isDisabled})
    }

    onAddOrEditIcon = () => {
        const formData = new FormData()
        const {editingMeta} = this.state
        if (!editingMeta) {
            formData.append('type', metaReverseLookup[this.state.selectedCategory])
            formData.append('name', this.formFieldInputs.name.state.value)
            if (this.state.useImgFromUrl) formData.append('imageUrl', this.formFieldInputs.imageUrl.state.value)
            else formData.append('image', this.formFieldInputs.image.state.value[0])
            this.props.createMeta(formData, () => clearFormFields(this.formFieldInputs))
        } else {
            formData.append('name', this.formFieldInputs.name.state.value)
            if (this.state.useImgFromUrl) formData.append('imageUrl', this.formFieldInputs.imageUrl.state.value)
            else if (this.formFieldInputs.image.state.value[0]) formData.append('image', this.formFieldInputs.image.state.value[0])
            this.props.editMeta(editingMeta.id, formData, () => {
                clearFormFields(this.formFieldInputs)
                this.onStopEditing()
            })
        }
    }

    onMenuItemClick = selectedCategory => () => {
        this.setState({selectedCategory})
    }

    onDeleteIcon = item => {
        this.props.deleteMeta(item.id)
    }

    onEditIcon = editingMeta => {
        this.formFieldInputs.name.setValue(editingMeta.name)
        this.setState({editingMeta})
    }

    onStopEditing = () => {
        this.setState({editingMeta: false})
        clearFormFields(this.formFieldInputs)
    }

    metaMenuOptions = [
        {label: 'Edit', icon: <Edit />, onClick: this.onEditIcon},
        {label: 'Delete', icon: <Delete />, onClick: this.onDeleteIcon, danger: true}
    ]

    render() {
        const {classes: styles, isUploadingMeta, isFetchingMetas, isUpdatingMeta, user} = this.props
        if (!user) return <Redirect to={'/'} />

        const metas = metaActions.util.formatToGroupedMetas(this.props.metas)

        return (
            <div className={styles.container}>
                <SideMenuDrawer>
                    <div className={styles.toolbar} />
                    <Typography variant={'body1'} className={styles.drawerTitle}>
                        Settings
                    </Typography>
                    <Divider />
                    <List>
                        {metaTypes.map((keyName, index) => {
                            const Icon = categoryIcons[keyName]
                            const isSelected = this.state.selectedCategory === keyName
                            return (
                                <ListItem className={isSelected ? styles.selectedCategoryItem : null} button onClick={this.onMenuItemClick(keyName)} key={index}>
                                    <ListItemIcon>{<Icon className={isSelected ? styles.selectedCategoryItemText : null} />}</ListItemIcon>
                                    <ListItemText classes={{primary: isSelected ? styles.selectedCategoryItemText : null}} primary={toTitleCase(keyName)} />

                                    <ListItemSecondaryAction>
                                        <Typography className={styles.badge} variant="caption" color="inherit">{metas[keyName] ? metas[keyName].length : 0}</Typography>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )
                        })}
                    </List>
                </SideMenuDrawer>
                <PageContainer className={styles.pageContainer}>
                    <Paper className={styles.formContainer} elevation={3}>
                        <Typography variant={'h6'} className={styles.formTitle}>
                                Add New Icon
                        </Typography>

                        {this.formFields().map((props, index) => (
                            <FormElement key={index} {...props} innerRef={ref => (this.formFieldInputs[props.name] = ref || this.formFieldInputs[props.name])} onValidationChangeDetected={this.onValidationChangeDetected} disabled={(props.name === 'imageUrl' && !this.state.useImgFromUrl) || (props.name === 'image' && this.state.useImgFromUrl)} />
                        ))}
                        <div className={styles.actionButtonsContainer}>
                            <SubmitButton className={styles.submitButton} isDisabled={this.state.isDisabled} isProcessing={isUploadingMeta || isUpdatingMeta} onClick={this.onAddOrEditIcon} loadingText={this.state.editingMeta ? 'Saving..' : 'Uploading..'}>{this.state.editingMeta ? 'Save Changes' : 'Submit'}</SubmitButton>
                            { this.state.editingMeta && (
                                <Button variant="contained" color="secondary" className={styles.stopEditingButton} onClick={this.onStopEditing}>
                                    <Close className={styles.stopEditingIcon} />
                                    Discard Changes
                                </Button>
                            )}
                        </div>
                    </Paper>

                    <div className={styles.iconsContainer}>
                        {isFetchingMetas
                            ? <Loader loaderText={'Getting Meta'} isLoading marginTop={'0em'} />
                            : metas[this.state.selectedCategory] && metas[this.state.selectedCategory].map((icon, index) => (
                                <MenuButton key={index} id={icon.id} options={this.metaMenuOptions} subject={icon}>
                                    <ArrowToolTip title={icon.name} placement={'bottom'}>
                                        <img alt={icon.name} src={`${apiResourcesUrl}/meta/${icon.iconUrl}`} className={styles.iconItem} />
                                    </ArrowToolTip>
                                </MenuButton>
                            ))}

                    </div>
                </PageContainer>
            </div>
        );
    }
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Settings))
